var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTether(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17162_78969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9148 44.7086C66.1068 63.9945 46.5733 75.7315 27.2851 70.9222C8.005 66.1142 -3.73202 46.5794 1.07815 27.2951C5.8841 8.00709 25.4176 -3.73082 44.6998 1.07724C63.9866 5.8853 75.7229 25.4221 70.9143 44.7089L70.9147 44.7086H70.9148Z",
    fill: "#50AF95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5552 40.0813C40.3006 40.1004 38.9854 40.1789 36.0517 40.1789C33.7183 40.1789 32.0616 40.1089 31.4804 40.0813C22.4628 39.6847 15.7321 38.1149 15.7321 36.2355C15.7321 34.356 22.4628 32.7884 31.4804 32.3854V38.518C32.0701 38.5604 33.7586 38.6601 36.092 38.6601C38.8921 38.6601 40.2943 38.5434 40.5467 38.5201V32.3896C49.5451 32.7905 56.2611 34.3603 56.2611 36.2355C56.2611 38.1107 49.5472 39.6804 40.5467 40.0792L40.5552 40.0813ZM40.5557 31.7553V26.2676H53.1137V17.8992H18.923V26.2676H31.4788V31.7532C21.2734 32.222 13.5986 34.2436 13.5986 36.6661C13.5986 39.0886 21.2734 41.108 31.4788 41.5789V59.1643H40.5536V41.5726C50.7357 41.1038 58.3978 39.0843 58.3978 36.6639C58.3978 34.2436 50.7421 32.2241 40.5536 31.7532L40.5557 31.7553Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17162_78969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTether);
export default __webpack_public_path__ + "static/media/tether.62a151b1884e16d8d11079b6e9fb7406.svg";
export { ForwardRef as ReactComponent };